import * as 마켓봄피쳐 from "./데이터/마켓봄피쳐";
import { 마켓봄_장점_Mobile2 } from "./마켓봄_장점_Mobile2";
import { 마켓봄_장점_리드_Mobile } from "./마켓봄_장점_리드_Mobile";
export type 마켓봄_장점과_리드_MobileProps = {
  마켓봄피쳐목록: readonly 마켓봄피쳐.마켓봄피쳐[];
};
export const 마켓봄_장점과_리드_Mobile = ({
  마켓봄피쳐목록,
}: 마켓봄_장점과_리드_MobileProps) => {
  return (
    <>
      <마켓봄_장점_Mobile2 선택된_목록={마켓봄피쳐목록} />
      <마켓봄_장점_리드_Mobile 선택된_목록={마켓봄피쳐목록} />
    </>
  );
};
